<div class="recording-actions" *ngIf="questions && questions.length > 0">
    <ul class="breadcrumb">
        <li *ngFor="let q of questions; let i = index">
            <a [ngClass]="{'selected' : q.selected}" (click)="loadQuestion(i)">{{i + 1}}</a>
        </li>
    </ul>
</div>
<div class="interview-header responses" *ngIf="currentItem">
    <h2 class="title question-title" tabindex="-1">{{currentItem?.question_text}}</h2>
</div>
<div class="interview-column">
    <div class="interview-container text-left">
        <div class="video-container">
            <div class="interview-video">
                <vg-player (onPlayerReady)="onPlayerReady($event)">
                    <div *ngIf=!playing class="video-overlay"></div>
                    <video [hidden]="answers" [autoplay]='autoplay && !answers' [vgMedia]="media" #media
                           id="questionVideo"
                           preload="auto" controls="true">
                        <source *ngIf="!answers" [src]="currentItem?.question_file" type="video/mp4">
                    </video>
                </vg-player>
            </div>
            <div class="interview-video">
                <vg-player (onPlayerReady)="onPlaybackReady($event)">
                    <div *ngIf="playing" class="video-overlay"></div>
                    <video [autoplay]='autoplay && answers' [vgMedia]="playback" #playback id="responseVideo"
                           preload="auto" controls="true">
                        <source [src]="currentItem?.answer_file" type="video/mp4">
                    </video>
                </vg-player>
            </div>
        </div>
        <div class="recording-actions">
            <div class="replay-actions" *ngIf="!_dataService.practice">
                <button (click)="updateResponseState('autoplay')" [ngClass]="{'selected': autoplay}"
                        class="btn btn_secondary"> {{'interviews.Autoplay' | translate}}
                </button>
                <button (click)="updateResponseState('answers')" [ngClass]="{'selected': answers}"
                        class="btn btn_secondary"> {{'interviews.Only Answers' | translate}}
                </button>
            </div>

        </div>
        <ng-content select=".feedback-form"></ng-content>
        <ng-content select=".actions"></ng-content>
        <ng-content select=".reviewer-feedback"></ng-content>
        <div class="replay-actions manager" *ngIf="questions.length > 1">
             <div class="paging-button">
                <button *ngIf="currentIndex > 0" (click)="loadQuestion(currentIndex - 1)" class="btn btn_secondary"><i class="icn icn-chevron_left"></i> Previous Question</button>
                <button *ngIf="!currentIndex || currentIndex !== (questions.length - 1)" (click)="loadQuestion(currentIndex + 1)" class="btn btn_primary">Next Question <i class="icn icn-chevron_right"></i></button>
             </div>
        </div>
    </div>
    <ng-content select=".other-attempts"></ng-content>
</div>
